<div class="table-container">
  <div class="data-card">
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" matSort>

    <!-- Reference Code Column -->
    <ng-container matColumnDef="refcode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Reference Code </th>
      <td mat-cell *matCellDef="let row">
        <span matRipple class="ref-code" [cdkCopyToClipboard]="row.referenceCode" (click)="onCopyRefCode(row.referenceCode)">{{row.referenceCode}}</span>
      </td>
    </ng-container>

    <!-- Brand Column -->
    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Brand </th>
      <td mat-cell *matCellDef="let row">{{row.brand}}</td>
    </ng-container>

    <!-- Agency/Office Column -->
    <ng-container matColumnDef="agency">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Agency/Office </th>
      <td mat-cell *matCellDef="let row">
        {{row.agency | objectdesc}}
        <div class="cell-secondary">{{row.commercialOffice | objectdesc}}</div>
    </td>
    </ng-container>

    <!-- Format Column -->
    <ng-container matColumnDef="format">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Format </th>
      <td mat-cell *matCellDef="let row">{{row.type | objectdesc}}</td>
    </ng-container>

    <!-- Placement Name Column -->
    <ng-container matColumnDef="placementName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Placement Name </th>
      <td mat-cell *matCellDef="let row">{{row.placementName}}</td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
      <td mat-cell *matCellDef="let row">
        <span class="badge" [ngClass]="{
          'badge-new': row.status.id == 40,
          'badge-pending': row.status.id == 41,
          'badge-processing': row.status.id == 42,
          'badge-rejected': row.status.id == 43 || row.status.id == 44,
          'badge-reload': row.status.id == 45,
          'badge-approved': row.status.id == 46
        }">
          <span class="badge-dot"></span>
          {{row.status | objectdesc}}
        </span>
      </td>
    </ng-container>

    <!-- Created Column -->
    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Created </th>
      <td mat-cell *matCellDef="let row"> {{row.dateCreated | date:'d/M/yyyy'}} </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let row">
        <div class="actions">
          <button matButton class="act-btn" (click)="onViewHistory(row)" matTooltip="View History">
            <i class="fa-regular fa-message"></i>
          </button>
          @if( row.status.id == 44 ) {
            <button matButton class="act-btn" (click)="onViewSpecCheckReport(row)" matTooltip="View Spec Check Report">
              <i class="fa-solid fa-circle-info" style="color:#DC2606"></i>
            </button>
          }
          @if( allowUploadCreativity(row) ) {
            <button matButton class="act-btn" (click)="onUploadCreativity(row)" matTooltip="Upload Media">
              <i class="fa-solid fa-upload"></i>
            </button>
          }
          <!-- @if( allowEditCreativity ) {
            <button matButton class="act-btn" (click)="onEditCreativity(row)" matTooltip="Edit">
              <i class="fa-solid fa-pen-to-square"></i>
            </button>
          } -->
          @if( allowDeleteCreativity(row) ) {
            <button matButton class="act-btn danger" (click)="onDeleteCreativity(row)" matTooltip="Delete">
              <i class="fa-regular fa-trash-can"></i>
            </button>
          }
        </div>
      </td>
    </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      aria-label="Select page">
    </mat-paginator>
  </div>

  <!-- <button class="fab fab-left" (click)="onNewCreativity()">
    <i class="fa-solid fa-plus"></i>
    New Creativity
  </button> -->
</div>
